export default __webpack_public_path__ + "static/media/RuthyCandyCane.145e4891.gif";